package pl.mothdigital.neuronowi.components.sections.specialist

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.layout.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import pl.mothdigital.neuronowi.common.model.SpecialistData
import pl.mothdigital.neuronowi.common.resources.*
import pl.mothdigital.neuronowi.common.utils.*
import pl.mothdigital.neuronowi.components.*
import pl.mothdigital.neuronowi.components.text.*
import org.jetbrains.compose.web.css.keywords.auto

/**
 * Grid section displaying specialist's specializations.
 * Shows a grid of cards with icons, titles, and descriptions.
 *
 * @param title Section title (default: "Moje specjalizacje")
 * @param specializations List of specialization data to display
 */
@Composable
fun SpecializationsGridSection(
    title: String = StringResources.SECTION_TITLE_SPECIALIZATIONS,
    specializations: List<SpecialistData>
) {
    Section(
        attrs = Modifier
            .fillMaxWidth()
            .standardSectionPadding()
            .semiTransparentGreenBackground()
            .toAttrs()
    ) {
        Column(
            modifier = Modifier.fillMaxWidth().margin { auto }.gap(2.cssRem)
        ) {
            AppH2 { Text(title) }

            SimpleGrid(
                modifier = Modifier.fillMaxWidth().gap(1.5.cssRem),
                numColumns = numColumns(base = 1, sm = 1, md = 2, lg = 2, xl = 2)
            ) {
                specializations.forEach { info ->
                    SpecialistInfoCard(
                        icon = info.icon,
                        title = info.title,
                        description = info.description
                    )
                }
            }
        }
    }
}
